import React, { useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Button, TextField, Grid, Typography } from '@mui/material';

const RequestDocsDialogue = (props) => {
       const [requestNotes, setRequestNotes] = useState('')

       return (<Dialog
        open={props.open}
        onclose={() => props.clear()}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          Request Additional Documentation 
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="request-docs-alert-dialog-description">
            Please provide instructions to the client below about what additional documents you need from them.
           <TextField 
            sx={{ mt: 2}} 
            value={requestNotes} 
            onChange={(e) => setRequestNotes(e.target.value) } 
            text={"We need you to upload additional repair orders..."}
            fullWidth 
            multiline maxRows={10} minRows={3} /> 
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => props.clear()}>Cancel</Button>
          <Button color={'primary'} onClick={() => { props.clear(); props.onAction(requestNotes); }} autofocus>
            Send Request
          </Button>
        </DialogActions>
      </Dialog>)
}
export default RequestDocsDialogue;
